// Design System — e-prescription
// Paleta médica: azul, verde menta, gris claro, blanco.
// Importar en cualquier componente para acceder a los tokens de diseño.

export const DS = {
  blue: '#1f8f6b',
  blueDark: '#17755a',
  blueLightBg: '#eaf5f1',
  green: '#10b981',
  greenDark: '#059669',
  gray: '#f8fafc',
  grayMid: '#f1f5f9',
  border: '#e2e8f0',
  textPrimary: '#1e293b',
  textSecondary: '#64748b',
  error: '#ef4444',
  warning: '#f59e0b',
};

export const cardSx = {
  borderRadius: 3,
  boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
  border: `1px solid ${DS.border}`,
};

export const sectionBarSx = (color = DS.blue) => ({
  width: 4,
  height: 24,
  bgcolor: color,
  borderRadius: 2,
  mr: 1,
  flexShrink: 0,
});

export const primaryBtnSx = {
  px: 4,
  py: 1.5,
  bgcolor: DS.blue,
  borderRadius: 2,
  fontWeight: 700,
  fontSize: 14,
  textTransform: 'none' as const,
  boxShadow: '0 4px 12px rgba(31,143,107,0.25)',
  '&:hover': {
    bgcolor: DS.blueDark,
    boxShadow: '0 6px 16px rgba(31,143,107,0.35)',
  },
};

export const tableHeadCellSx = {
  fontWeight: 700,
  color: DS.textPrimary,
  borderBottom: `2px solid ${DS.border}`,
  bgcolor: DS.gray,
};
